import React from 'react';
import { Link } from 'react-router-dom';
import { MainImage } from '../../../../Shared/Content/ProductDetail/ProductMainImage/ProductMainImage';
import { AltImages, MainImageSlider } from '../../../../Shared/Content/ProductDetail/ProductAltImages/ProductAltImages';
import { Title } from '../../../../Shared/Content/ProductDetail/ProductTitle/ProductTitle';
import { Price } from '../../../../../UI/Price/Price';
import { Quantity } from '../../../../Shared/Content/ProductDetail/ProductQuantity/ProductQuantity';
import ProductDetailForm from '../../../../Shared/Content/ProductDetail/ProductDetailForm/ProductDetailForm';
import ProductDetailAttribute from '../../../../Shared/Content/ProductDetail/ProductDetailAttribute/ProductDetailAttribute';
import { ProductDescription } from '../../../../Shared/Content/ProductDetail/ProductDescription/ProductDescription';
import { WishListMessage } from '../../../../Shared/Content/ProductDetail/WishListMessage/WishListMessage';
import { CloseXIcon } from '../../../../../UI/Icons/Icons';
import Slider from 'react-slick';
import InvalidCombo from '../../../../Shared/Content/ProductDetail/InvalidCombo/InvalidCombo';
import { PhotoSwipeZoom, MainImagePhotoSwipeZoom } from '../PhotoSwipeZoom/PhotoSwipeZoom';
import ProductSubscription from '../../../../Shared/Content/ProductDetail/ProductSubscription/ProductSubscription';
import AddToBagButton from '../../../../Shared/Content/ProductDetail/AddToBagButton/AddToBagButton';
import ProductDetailSwatches from '../../../../Shared/Content/ProductDetail/ProductDetailSwatches/ProductDetailSwatches';

export class QuickViewDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      altClicked: false,
      altIndex: 0,
      siteFormat: this.props.passedAppFunctions ? this.props.passedAppFunctions.siteFormat : '',
      showColorNotAvailable: true,
    };
  }

  closeColorNotAvailable = () => {
    this.setState({ showColorNotAvailable: false });
  };

  closeErrorMessage() {
    this.setState({ errorMessage: false });
  }

  checkForErrors = () => {
    this.props.passedFunctions.checkForErrorsQV();
    this.ajaxAddToBag_qv();
  };

  checkForErrorsWishlist = () => {
    this.props.passedFunctions.checkForErrorsQV();
    this.ajaxAddToWishlist_qv();
  };

  ajaxAddToBag_qv = () => {
    this.props.passedFunctions.ajaxAddToBag();
  };

  ajaxAddToWishlist_qv = () => {
    this.props.passedFunctions.ajaxAddToWishlist();
  };

  openPhotoSwipe = (e) => {
    e.preventDefault();
    this.setState({
      isOpen: true,
      options: {
        index: this.zoomIndex,
        closeOnScroll: false,
      },
    });
  };

  handleClose = () => {
    let index = this.state.options.index;
    let parentThis = this;
    let altWrapper = document.querySelector('#QuickViewDisplay #product-alt-wrapper');
    if (parentThis.props.contentData.altImages === undefined) {
    } else {
      // if the alt image isn't lazyloaded - click it.
      // if the swipe image's corresponding alt container is lazyloaded, the mutation observer will take care of the click.
      let altImageToUse = parentThis.props.contentData.altImages[index];
      let imageName = altImageToUse.imageName;
      if (document.getElementById(imageName) === null) {
        if (altWrapper !== null) {
          var altToClick = altWrapper.querySelector(`[data-index='${index}']`);
          altToClick.click();
        }
        var observer = new MutationObserver(function (mutations, slickObserver) {
          mutations.forEach(function (mutation) {
            if (mutation.type === 'childList') {
              var altButtonToClick = mutation.target.firstElementChild.firstElementChild;
              if (altButtonToClick !== null) {
                altButtonToClick.click();
                slickObserver.disconnect();
              }
            }
          });
        });
        var slideToWatch = altWrapper.querySelector(`[data-index='${index}']`);
        var observerOptions = { childList: true, subtree: true };
        observer.observe(slideToWatch, observerOptions);
      } else {
        document.getElementById(imageName).click();
      }
    }
    this.setState({ isOpen: false });
  };

  updateZoomIndex = (i) => {
    this.zoomIndex = i;
  };

  openPhotoSwipeMain = (e) => {
    let dataKey = parseInt(e.target.getAttribute('data-key'));
    this.setState({
      isOpen: true,
      options: {
        index: dataKey,
        closeOnScroll: false,
      },
    });
  };

  render() {
    var settings = {
      containsOSS: this.props.contentData.extraQVProps && this.props.contentData.extraQVProps.OSS ? true : false,
      containsCollection:
        this.props.contentData.extraQVProps && this.props.contentData.extraQVProps.collection ? true : false,
      containsAlts: this.props.contentData.altImages ? true : false,
    };
    var qvPlus = false,
      qvPlusList_gt3 = false;
    if (settings.containsCollection) {
      qvPlus = true;
      if (this.props.contentData.extraQVProps.collection.details.length > 3) qvPlusList_gt3 = true;
    } else if (settings.containsOSS) {
      qvPlus = true;
      if (this.props.contentData.extraQVProps.OSS.length > 3) qvPlusList_gt3 = true;
    }
    var settingsStayVertical = {
      dots: false,
      infinite: false,
      vertical: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      swipe: true,
      lazyLoad: true,
      arrows: qvPlus ? (qvPlusList_gt3 ? true : false) : '',
    };

    var settingsTablet = {
      dots: false,
      infinite: false,
      vertical: false,
      speed: 500,
      slidesToShow: 4.5,
      swipe: true,
      swipeToSlide: true,
      lazyLoad: true,
      arrows: false,
    };

    var mainImageSize = {
      mainImgWidth: settings.containsOSS || settings.containsCollection === true ? 318 : 390,
      mainImgHeight: settings.containsOSS || settings.containsCollection === true ? 369 : 452,
    };

    var mainImgCol = '',
      shopperActionsCol = '';
    if (this.state.siteFormat == 'desktop') {
      mainImgCol = settings.containsOSS || settings.containsCollection ? 'col-sm-5' : 'col-sm-6';
      shopperActionsCol =
        (settings.containsOSS || settings.containsCollection) && settings.containsAlts ? 'col-sm-4' : 'col-sm-5';
    } else {
      mainImgCol = 'col-sm-7 p-l-25 p-r-25';
      shopperActionsCol = 'col-sm-5';
    }
    let preOrder = this.props.contentData.preOrder,
      previewItem = preOrder !== undefined && preOrder.previewEndDateMessage !== undefined ? true : false;

    return (
      <section id='QuickViewDisplay' aria-hidden='false'>
        <div className='row m-0'>
          {this.state.siteFormat != 'desktop' &&
          this.props.contentData.extraQVProps &&
          this.props.contentData.extraQVProps.OSS ? (
            <div className='col-12 ossAccessories'>
              <div className='row ossHeaderRow'>
                <div className='col-sm-10'>
                  <h2 className='ossHeader'>Complete Your Look</h2>
                </div>
                <div className='col-sm-2'>
                  <button
                    className='close btn-tertiary'
                    type='button'
                    onClick={this.props.passedAppFunctions.closeQuickView}
                  >
                    <CloseXIcon />
                  </button>
                </div>
              </div>
              <Slider {...settingsTablet}>
                {this.props.contentData.extraQVProps.OSS.map((currentOSSAccessory, index) => (
                  <div
                    className={`item ${currentOSSAccessory.dil_oss_acc_catentry_id == this.props.contentData.productId ? 'active-oss' : ''}`}
                    key={currentOSSAccessory.dil_oss_acc_fullImage}
                  >
                    {currentOSSAccessory.dil_oss_acc_catentry_id == this.props.contentData.productId ? (
                      <div>
                        <img
                          src={`//dimg.dillards.com/is/image/DillardsZoom/productRec/${'-'}/${currentOSSAccessory.dil_oss_acc_fullImage}.jpg`}
                        />
                      </div>
                    ) : (
                      <Link
                        to={{
                          pathname: `/p/${'-'}/${currentOSSAccessory.dil_oss_acc_catentry_id}`,
                          state: { qv: true, extraQVProps: { OSS: this.props.contentData.extraQVProps.OSS } },
                        }}
                        replace
                      >
                        <img
                          src={`//dimg.dillards.com/is/image/DillardsZoom/productRec/${'-'}/${currentOSSAccessory.dil_oss_acc_fullImage}.jpg`}
                        />
                      </Link>
                    )}
                  </div>
                ))}
              </Slider>
            </div>
          ) : (
            ''
          )}
          {this.state.siteFormat != 'desktop' &&
          this.props.contentData.extraQVProps &&
          this.props.contentData.extraQVProps.collection ? (
            <div className='col-12 ossAccessories'>
              <div className='row ossHeaderRow'>
                <div className='col-sm-10'>
                  <h2 className='ossHeader'>Other Styles In This Group</h2>
                </div>
                <div className='col-sm-2'>
                  <button
                    className='close btn-tertiary'
                    type='button'
                    onClick={this.props.passedAppFunctions.closeQuickView}
                  >
                    <CloseXIcon />
                  </button>
                </div>
              </div>
              <Slider {...settingsTablet}>
                {this.props.contentData.extraQVProps.collection.details.map((currentCollectionItem, index) => (
                  <figure
                    className={`item ${currentCollectionItem.catentryId == this.props.contentData.productId ? 'active-oss' : ''}`}
                    key={currentCollectionItem.catentryId}
                  >
                    {currentCollectionItem.catentryId == this.props.contentData.productId ? (
                      <div>
                        <img
                          src={`//dimg.dillards.com/is/image/DillardsZoom/productRec/${currentCollectionItem.keyword}/${currentCollectionItem.imageName}.jpg`}
                        />
                      </div>
                    ) : (
                      <Link
                        to={{
                          pathname: `/p/${currentCollectionItem.keyword}/${currentCollectionItem.catentryId}`,
                          state: {
                            qv: true,
                            extraQVProps: {
                              collection: this.props.contentData.extraQVProps.collection,
                              thisCollectionMember: currentCollectionItem,
                            },
                          },
                        }}
                        replace
                      >
                        <img
                          src={`//dimg.dillards.com/is/image/DillardsZoom/productRec/${currentCollectionItem.keyword}/${currentCollectionItem.imageName}.jpg`}
                        />
                      </Link>
                    )}
                  </figure>
                ))}
              </Slider>
            </div>
          ) : (
            ''
          )}

          {this.state.siteFormat == 'tablet' && (settings.containsOSS || settings.containsCollection) ? (
            ''
          ) : (
            <div className={`${settings.containsOSS || settings.containsCollection ? 'col-sm-10' : 'col-sm-12'}`}>
              <button
                type='button'
                className='close btn-tertiary'
                onClick={this.props.passedAppFunctions.closeQuickView}
              >
                <CloseXIcon />
              </button>
            </div>
          )}
          {this.state.siteFormat != 'tablet' && (settings.containsOSS || settings.containsCollection) ? (
            <div className='col-sm-2'>{/* this is to position the X properly if your in OSS quickview */}</div>
          ) : (
            ''
          )}
          {settings.containsAlts && this.state.siteFormat == 'desktop' ? (
            <div className='col-sm-1 p-0'>
              <AltImages
                contentData={this.props.contentData}
                passedFunctions={this.props.passedFunctions}
                qvSlidesToShow={4}
                passedAppFunctions={this.props.passedAppFunctions}
                selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                selectedAttributeValue={this.props.passedFunctions.parentState.selectedAttributeValue}
                altClicked={this.props.altClicked}
              />
            </div>
          ) : (
            ''
          )}
          <div className={`${this.state.siteFormat == 'tablet' ? '' : 'p-0'} ${mainImgCol}`}>
            {this.props.passedAppFunctions.siteFormat == 'desktop' ? (
              <MainImage
                currentAttributeState={this.props.passedFunctions.parentState.currentAttributeState}
                contentData={this.props.contentData}
                selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                passedFunctions={this.props.passedFunctions}
                passedAppFunctions={this.props.passedAppFunctions}
                mainImgWidth={mainImageSize.mainImgWidth}
                mainImgHeight={mainImageSize.mainImgHeight}
                quickViewMainImage={true}
              />
            ) : (
              <MainImagePhotoSwipeZoom
                isOpen={this.state.isOpen}
                options={this.state.options}
                handleClose={this.handleClose}
                passedFunctions={this.props.passedFunctions}
                contentData={this.props.contentData}
                selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                updateZoomIndex={this.updateZoomIndex}
              />
            )}
            {this.props.passedAppFunctions.siteFormat != 'desktop' && (
              <MainImageSlider
                contentData={this.props.contentData}
                passedFunctions={this.props.passedFunctions}
                passedAppFunctions={this.props.passedAppFunctions}
                selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                openPhotoSwipeMain={this.openPhotoSwipeMain}
                altClicked={this.state.altClicked}
                altIndex={this.state.altIndex}
              />
            )}
            {settings.containsAlts && this.state.siteFormat == 'tablet' && (
              //Alts displayed below MainImage for tablet.
              <AltImages
                contentData={this.props.contentData}
                passedFunctions={this.props.passedFunctions}
                vertical={false}
                qvSlidesToShow={3.5}
                passedAppFunctions={this.props.passedAppFunctions}
                selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                selectedAttributeValue={this.props.passedFunctions.parentState.selectedAttributeValue}
                altClicked={this.props.altClicked}
              />
            )}
          </div>
          <div
            className={`${
              (this.state.siteFormat != 'tablet' && settings.containsOSS) || settings.containsCollection ? '' : 'p-0'
            } ${'m-0'} ${shopperActionsCol}`}
          >
            <div className='qv-scrollable'>
              <Title contentData={this.props.contentData} passedAppFunctions={this.props.passedAppFunctions} />
              <Price
                pricing={this.props.contentData.pricing}
                qv={true}
                showFreeShipping={
                  this.props.passedAppFunctions.siteFormat == 'desktop'
                    ? this.props.passedFunctions.shouldShowFreeShipping()
                    : ''
                }
              />
              <div className='panel'>
                <Link
                  to={{
                    pathname: `/p/${this.props.contentData.productNameForURL}/${this.props.contentData.productId}${
                      this.props.contentData.salePage == 'true' ? '/sale' : ''
                    }${
                      this.props.passedAppFunctions.getURLParamValue('df') != ''
                        ? '?df=' + this.props.passedAppFunctions.getURLParamValue('df')
                        : ''
                    }`,
                    state: {
                      fromQv: true,
                    },
                  }}
                  replace
                  className='qvProductPageLink'
                >
                  See Full Details
                </Link>
              </div>

              {this.props.passedFunctions.colorNotAvailable && this.state.showColorNotAvailable ? (
                <div className='alert alert-danger'>
                  <button className='close btn-tertiary' type='button' onClick={this.closeColorNotAvailable}>
                    <CloseXIcon />
                  </button>
                  The color &quot;{this.props.passedFunctions.colorNotAvailable}&quot; is not available.
                </div>
              ) : (
                ''
              )}
              {this.props.contentData.isInternational == 'Y' || !this.props.passedAppFunctions.isInternational() ? (
                <React.Fragment>
                  {!previewItem ? (
                    <React.Fragment>
                      <ProductDetailForm
                        currentAttributeState={this.props.currentAttributeState}
                        passedFunctions={this.props.passedFunctions}
                        contentData={this.props.contentData}
                        wrapperClass={this.props.wrapperClass}
                      >
                        <ProductDetailAttribute
                          passedFunctions={this.props.passedFunctions}
                          passedAppFunctions={this.props.passedAppFunctions}
                          updateAttribute={this.props.passedFunctions.updateAttribute}
                          updateAttrState={this.props.passedFunctions.updateAttrState}
                          currentAttributeState={this.props.currentAttributeState}
                          contentData={this.props.contentData}
                          quickView={true}
                        />

                        {this.props.contentData.productContainsRegPricedMerch == 'true' &&
                        this.props.contentData.productContainsSalePricedMerch == 'false' ? (
                          ''
                        ) : (
                          <Quantity
                            updateQuantity={this.props.passedFunctions.updateQuantity}
                            quantity={this.props.passedFunctions.parentState.quantity}
                            quantityErrored={this.props.passedFunctions.parentState.quantityErrored}
                            contentData={this.props.contentData}
                            passedAppFunctions={this.props.passedAppFunctions}
                            forceQuantity={this.props.passedFunctions.forceQuantity}
                          />
                        )}
                      </ProductDetailForm>

                      {this.props.contentData.productContainsRegPricedMerch == 'true' &&
                      this.props.contentData.productContainsSalePricedMerch == 'false' ? (
                        <div className='form-group m-t-10'>
                          {this.props.contentData.salePage == 'true' &&
                          this.props.contentData.productContainsSalePricedMerch == 'false' ? (
                            <span className='d-block regularPriceOptionsText'>
                              This item is no longer available in Sale and Clearance.
                            </span>
                          ) : (
                            ''
                          )}
                          <Link
                            to={`/p/${this.props.contentData.productNameForURL}/${this.props.contentData.productId}`}
                            className='regularPriceOptions'
                          >
                            See Regular Price Options
                          </Link>
                        </div>
                      ) : null}
                      {this.props.contentData.productSubscriptionEligible == 'Y' ? (
                        <ProductSubscription
                          contentData={this.props.contentData}
                          passedFunctions={this.props.passedFunctions}
                          passedAppFunctions={this.props.passedAppFunctions}
                        />
                      ) : null}
                      {this.props.contentData.productContainsRegPricedMerch == 'true' &&
                      this.props.contentData.productContainsSalePricedMerch == 'false' ? (
                        ''
                      ) : (
                        <footer className={`${'qv-footer'} ${this.state.descriptionClosed ? '' : 'qvStickyFooter'}`}>
                          <div className='addToBagContainer'>
                            <InvalidCombo
                              passedFunctions={this.props.passedFunctions}
                              passedAppFunctions={this.props.passedAppFunctions}
                              currentAttributeState={this.props.currentAttributeState}
                            />

                            <AddToBagButton passedFunctions={this.props.passedFunctions} />
                          </div>
                          <WishListMessage
                            passedFunctions={this.props.passedFunctions}
                            passedAppFunctions={this.props.passedAppFunctions}
                          />
                          {!this.props.passedAppFunctions.isInternational() ? (
                            <button
                              className='btn btn-tertiary btn-block'
                              role='button'
                              id='add-to-wishlist'
                              type='button'
                              onClick={this.checkForErrorsWishlist}
                            >
                              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 15.58 12.44' aria-hidden='true'>
                                <title>heart</title>
                                <g data-name='Layer 2'>
                                  <g data-name='Layer 1'>
                                    <path
                                      className='cls-1'
                                      d='M7.79,12.44a.54.54,0,0,1-.32-.11L1.66,7.46l0,0A4.78,4.78,0,0,1,0,4.14,4.15,4.15,0,0,1,4.14,0,4.13,4.13,0,0,1,7.82,2.14,4.19,4.19,0,1,1,14.3,7.33l-6.19,5A.5.5,0,0,1,7.79,12.44ZM2.32,6.71,7.8,11.29l5.84-4.71a3.15,3.15,0,0,0-2.21-5.4,3,3,0,0,0-3.08,2.4.51.51,0,0,1-.07.17A.64.64,0,0,1,7.83,4a.5.5,0,0,1-.44-.18,1.3,1.3,0,0,1-.14-.29A3,3,0,0,0,4.14,1,3.15,3.15,0,0,0,1,4.14,3.66,3.66,0,0,0,2.32,6.71Z'
                                    />
                                  </g>
                                </g>
                              </svg>
                              Add To Wish List
                            </button>
                          ) : (
                            ''
                          )}
                          {!this.props.passedAppFunctions.isInternational() ? (
                            <button
                              className='btn btn-tertiary btn-block'
                              role='button'
                              type='button'
                              id='add-to-registry'
                              onClick={this.props.passedFunctions.checkForErrorsRegistry}
                            >
                              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 50.42 49.84' aria-hidden='true'>
                                <title>gift</title>
                                <g data-name='Layer 2'>
                                  <g data-name='Layer 1'>
                                    <path d='M48,9.79H39.64a5.33,5.33,0,0,0-1-9.43,5.3,5.3,0,0,0-4.09.1c-2.16,1-8,7.3-9.37,8.82C23.8,7.76,18,1.42,15.81.46a5.33,5.33,0,0,0-5.1,9.33H2.45A2.45,2.45,0,0,0,0,12.24v4.39a2.45,2.45,0,0,0,2.45,2.45H3a3.46,3.46,0,0,0-.53,1.84V46.35a3.5,3.5,0,0,0,3.49,3.49H44.41a3.5,3.5,0,0,0,3.49-3.49V20.92a3.46,3.46,0,0,0-.53-1.84H48a2.45,2.45,0,0,0,2.45-2.45V12.24A2.45,2.45,0,0,0,48,9.79ZM35.36,2.3A3.32,3.32,0,0,1,38,8.39c-1.2.53-6.12.76-10.05.81C30.68,6.32,34.16,2.83,35.36,2.3ZM10.61,4A3.33,3.33,0,0,1,15,2.3c1.2.53,4.68,4,7.36,6.89-3.93,0-8.85-.28-10.05-.81h0A3.33,3.33,0,0,1,10.61,4ZM2,16.63V12.24a.43.43,0,0,1,.43-.43H24.2v5.26H2.45A.43.43,0,0,1,2,16.63ZM4.47,46.35V20.92a1.48,1.48,0,0,1,1.48-1.48H24.2V47.82H5.94A1.48,1.48,0,0,1,4.47,46.35Zm41.42,0a1.48,1.48,0,0,1-1.48,1.48H26.22V19.44H44.41a1.48,1.48,0,0,1,1.48,1.48Zm2.52-29.71a.43.43,0,0,1-.43.43H26.22V11.81H48a.43.43,0,0,1,.43.43Z' />
                                  </g>
                                </g>
                              </svg>
                              Add To Registry
                            </button>
                          ) : (
                            ''
                          )}
                        </footer>
                      )}
                    </React.Fragment>
                  ) : (
                    ''
                  )}
                </React.Fragment>
              ) : (
                <div id='error-message' className='alert alert-danger' role='alert'>
                  This item is not available for international purchase.
                </div>
              )}
            </div>
          </div>
          {this.props.contentData.extraQVProps &&
          this.props.contentData.extraQVProps.OSS &&
          this.state.siteFormat != 'tablet' ? (
            <div className='ossAccessories m-0 p-0 col-sm-2'>
              <h2 className='ossHeader'>COMPLETE YOUR LOOK</h2>
              {this.props.contentData.extraQVProps.OSS.length > 3 ? (
                <Slider {...settingsStayVertical}>
                  {this.props.contentData.extraQVProps.OSS.map((currentOSSAccessory, index) => (
                    <div
                      className={`item ${currentOSSAccessory.dil_oss_acc_catentry_id == this.props.contentData.productId ? 'active-oss' : ''}`}
                      key={currentOSSAccessory.dil_oss_acc_fullImage}
                    >
                      {currentOSSAccessory.dil_oss_acc_catentry_id == this.props.contentData.productId ? (
                        <div>
                          <img
                            src={`//dimg.dillards.com/is/image/DillardsZoom/productRec/${'-'}/${currentOSSAccessory.dil_oss_acc_fullImage}.jpg`}
                          />
                        </div>
                      ) : (
                        <Link
                          to={{
                            pathname: `/p/${'-'}/${currentOSSAccessory.dil_oss_acc_catentry_id}`,
                            state: { qv: true, extraQVProps: { OSS: this.props.contentData.extraQVProps.OSS } },
                          }}
                          replace
                        >
                          <img
                            src={`//dimg.dillards.com/is/image/DillardsZoom/productRec/${'-'}/${currentOSSAccessory.dil_oss_acc_fullImage}.jpg`}
                          />
                        </Link>
                      )}
                    </div>
                  ))}
                </Slider>
              ) : (
                ''
              )}
              {this.props.contentData.extraQVProps.OSS.length <= 3
                ? this.props.contentData.extraQVProps.OSS.map((currentOSSAccessory, index) => (
                    <div
                      className={`item ${currentOSSAccessory.dil_oss_acc_catentry_id == this.props.contentData.productId ? 'active-oss' : ''}`}
                      key={currentOSSAccessory.dil_oss_acc_fullImage}
                    >
                      {currentOSSAccessory.dil_oss_acc_catentry_id == this.props.contentData.productId ? (
                        <div>
                          <img
                            src={`//dimg.dillards.com/is/image/DillardsZoom/productRec/${'-'}/${currentOSSAccessory.dil_oss_acc_fullImage}.jpg`}
                          />
                        </div>
                      ) : (
                        <Link
                          to={{
                            pathname: `/p/${'-'}/${currentOSSAccessory.dil_oss_acc_catentry_id}`,
                            state: { qv: true, extraQVProps: { OSS: this.props.contentData.extraQVProps.OSS } },
                          }}
                          replace
                        >
                          <img
                            src={`//dimg.dillards.com/is/image/DillardsZoom/productRec/${'-'}/${currentOSSAccessory.dil_oss_acc_fullImage}.jpg`}
                          />
                        </Link>
                      )}
                    </div>
                  ))
                : ''}
            </div>
          ) : (
            ''
          )}
          {this.props.contentData.extraQVProps &&
          this.props.contentData.extraQVProps.collection &&
          this.state.siteFormat != 'tablet' ? (
            <div className='ossAccessories m-0 p-0 col-sm-2'>
              <h2 className='ossHeader'>Other Styles In This Group</h2>
              {this.props.contentData.extraQVProps.collection.details.length > 3 ? (
                <Slider {...settingsStayVertical}>
                  {this.props.contentData.extraQVProps.collection.details.map((currentCollectionItem, index) => (
                    <figure
                      className={`item ${currentCollectionItem.catentryId == this.props.contentData.productId ? 'active-oss' : ''}`}
                      key={`${index}${currentCollectionItem.imageName}`}
                    >
                      {currentCollectionItem.catentryId == this.props.contentData.productId ? (
                        <div>
                          <img
                            src={`//dimg.dillards.com/is/image/DillardsZoom/productRec/${currentCollectionItem.keyword}/${currentCollectionItem.imageName}.jpg`}
                          />
                        </div>
                      ) : (
                        <Link
                          to={{
                            pathname: `/p/${currentCollectionItem.keyword}/${currentCollectionItem.catentryId}`,
                            state: {
                              qv: true,
                              extraQVProps: {
                                collection: this.props.contentData.extraQVProps.collection,
                                thisCollectionMember: currentCollectionItem,
                              },
                            },
                          }}
                          replace
                        >
                          <img
                            src={`//dimg.dillards.com/is/image/DillardsZoom/productRec/${currentCollectionItem.keyword}/${currentCollectionItem.imageName}.jpg`}
                          />
                        </Link>
                      )}
                    </figure>
                  ))}
                </Slider>
              ) : (
                ''
              )}
              {this.props.contentData.extraQVProps.collection.details.length <= 3
                ? this.props.contentData.extraQVProps.collection.details.map((currentCollectionItem, index) => (
                    <figure
                      className={`item ${currentCollectionItem.catentryId == this.props.contentData.productId ? 'active-oss' : ''}`}
                      key={`${index}${currentCollectionItem.imageName}`}
                    >
                      {currentCollectionItem.catentryId == this.props.contentData.productId ? (
                        <div>
                          <img
                            src={`//dimg.dillards.com/is/image/DillardsZoom/productRec/${currentCollectionItem.keyword}/${currentCollectionItem.imageName}.jpg`}
                          />
                        </div>
                      ) : (
                        <Link
                          to={{
                            pathname: `/p/${currentCollectionItem.keyword}/${currentCollectionItem.catentryId}`,
                            state: {
                              qv: true,
                              extraQVProps: {
                                collection: this.props.contentData.extraQVProps.collection,
                                thisCollectionMember: currentCollectionItem,
                              },
                            },
                          }}
                          replace
                        >
                          <img
                            src={`//dimg.dillards.com/is/image/DillardsZoom/productRec/${currentCollectionItem.keyword}/${currentCollectionItem.imageName}.jpg`}
                          />
                        </Link>
                      )}
                    </figure>
                  ))
                : ''}
            </div>
          ) : (
            ''
          )}
        </div>
      </section>
    );
  }
}

export default QuickViewDisplay;
